import actionTypes from '../constants/action-types';

const setSiteProperty = (property, value) => ({
  type: actionTypes.SET_SITE_PROPERTY,
  payload: {
    property,
    value,
  },
});

export default setSiteProperty;
